import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { BreadcrumbComponent } from '../../Components/BreadCrumb';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useBuilding } from '../../Helpers/BuildingContext';
import { useUserNames } from '../../Helpers/useUserNames';
import TodosList from './TodosList';
import './TodosPage.css';

const TodosPage: React.FC = () => {
    const { id: buildingKey, userId } = useParams<{ id?: string; userId?: string }>();
    const { currentBuilding } = useBuilding();

    // Determine context (building or user)
    const isUserContext = !!userId;

    // Get user names for display
    const { userNames } = useUserNames();

    // Get building name for title
    const buildingName = currentBuilding?.summary.name || 'Byggnad';

    // Get context name for page title
    const contextName = isUserContext
        ? (userId && userNames[userId]) || 'Användare'
        : buildingName;

    // Get header title based on context
    const headerTitle = isUserContext
        ? 'Mina personliga att göra'
        : `Att göra för ${buildingName}`;

    // Description based on context
    const headerDescription = isUserContext
        ? 'Dessa uppgifter är endast synliga för dig.'
        : 'Dessa uppgifter är synliga för alla användare med tillgång till byggnaden.';

    const breadcrumbItems = [
            { text: buildingName, link: `/building/${buildingKey}` },
            { text: 'Att göra' },
          ];

    // Set document title
    useDocumentTitle(`Att göra - ${contextName}`);

    return (
        <>
            <BreadcrumbComponent
                items={breadcrumbItems}
                rootItem={isUserContext ? null : undefined}
            />

            <Container className="todos-page content-container-narrow">
                <TodosList
                    userId={userId}
                    buildingKey={buildingKey}
                    showHeader={true}
                    headerTitle={headerTitle}
                    headerDescription={headerDescription}
                />
            </Container>
        </>
    );
};

export default TodosPage;
